export default function getCardStatus(setShowOverlay, setCardStatus, setError, setMessage) {
    if (!window.OrendaGetResponse || window.isSiteBuilder) {
      setTimeout(() => {
        setCardStatus("Active");
        setShowOverlay(false);
      }, 1000);
      return;
    }

    return window.OrendaGetResponse({ event_name: "getCardStatus" }, (response) => {
      if (response.error) return setError(true);
      if (response.message) return setMessage(response.message);
      setCardStatus(response.cardStatus);
      setShowOverlay(false);
      return;
    });
  }
  